// extracted by mini-css-extract-plugin
module.exports = {"starView":"index_starView__3TFD9","view":"index_view__2zC8o","star1":"index_star1__oNl7d","star2":"index_star2__3Cuf4","diImg":"index_diImg__1bA9I","caiImg":"index_caiImg__1nx2p"};